module.exports = __webpack_public_path__ + "img/img17.cef7a29b.jpg";